// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2OoPy","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2lFur"};